export default "__VITE_ASSET__Bub4F6t$__"